/* Landing page interactions — used only by welcome.blade.php */
(function () {
    'use strict';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealAll() {
        document.querySelectorAll('[data-animate]').forEach((el) => el.classList.add('in-view'));
    }

    function init() {
        try {
            setupReveal();
            setupCounters();
            setupNav();
            setupTimeline();
            setupTilt();
        } catch (e) {
            // Never let animation wiring block the page
            revealAll();
        }
    }

    /* Scroll reveal */
    function setupReveal() {
        if (!('IntersectionObserver' in window) || reducedMotion) {
            revealAll();
            return;
        }
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('in-view');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
        );
        document.querySelectorAll('[data-animate]').forEach((el) => observer.observe(el));
    }

    /* Count-up numbers: <span data-countup data-target="1248" data-suffix="+">1,248+</span> */
    function setupCounters() {
        const counters = document.querySelectorAll('[data-countup]');
        if (!counters.length) return;
        if (!('IntersectionObserver' in window) || reducedMotion) return; // markup already shows final values

        const animate = (el) => {
            const target = parseFloat(el.dataset.target || '0');
            const suffix = el.dataset.suffix || '';
            const decimals = (el.dataset.target || '').includes('.') ? 1 : 0;
            const duration = 1800;
            const startTime = performance.now();
            const step = (now) => {
                const progress = Math.min((now - startTime) / duration, 1);
                const eased = 1 - Math.pow(1 - progress, 3);
                const value = target * eased;
                el.textContent =
                    (decimals ? value.toFixed(decimals) : Math.round(value).toLocaleString()) + suffix;
                if (progress < 1) requestAnimationFrame(step);
            };
            requestAnimationFrame(step);
        };

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        animate(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.4 }
        );
        counters.forEach((el) => observer.observe(el));
    }

    /* Nav scrolled state */
    function setupNav() {
        const nav = document.querySelector('.landing-nav');
        if (!nav) return;

        let ticking = false;
        const update = () => {
            nav.classList.toggle('scrolled', window.scrollY > 24);
            ticking = false;
        };
        window.addEventListener(
            'scroll',
            () => {
                if (!ticking) {
                    ticking = true;
                    requestAnimationFrame(update);
                }
            },
            { passive: true }
        );
        update();
    }

    /* Timeline draw-down progress */
    function setupTimeline() {
        const progress = document.querySelector('.timeline-progress');
        const section = document.querySelector('#how-it-works');
        if (!progress || !section || reducedMotion) {
            if (progress) progress.style.transform = 'scaleY(1)';
            return;
        }
        let ticking = false;
        const update = () => {
            const rect = section.getBoundingClientRect();
            const viewH = window.innerHeight;
            const total = rect.height + viewH * 0.5;
            const passed = Math.min(Math.max(viewH * 0.75 - rect.top, 0), total);
            progress.style.transform = 'scaleY(' + (passed / total).toFixed(3) + ')';
            ticking = false;
        };
        window.addEventListener(
            'scroll',
            () => {
                if (!ticking) {
                    ticking = true;
                    requestAnimationFrame(update);
                }
            },
            { passive: true }
        );
        update();
    }

    /* Hero mockup tilt toward cursor (desktop only) */
    function setupTilt() {
        const tilt = document.querySelector('.hero-tilt');
        if (!tilt || reducedMotion) return;
        const maxDeg = 6;
        document.addEventListener(
            'mousemove',
            (e) => {
                if (window.innerWidth < 1024) {
                    tilt.style.transform = '';
                    return;
                }
                const rect = tilt.getBoundingClientRect();
                if (rect.width === 0) return;
                const cx = rect.left + rect.width / 2;
                const cy = rect.top + rect.height / 2;
                const dx = Math.max(-1, Math.min(1, (e.clientX - cx) / (rect.width * 1.2)));
                const dy = Math.max(-1, Math.min(1, (e.clientY - cy) / (rect.height * 1.2)));
                tilt.style.transform =
                    'perspective(1100px) rotateY(' + (dx * maxDeg).toFixed(2) + 'deg) rotateX(' + (-dy * maxDeg).toFixed(2) + 'deg)';
            },
            { passive: true }
        );
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
